import { imageApplyDataAttr } from './helpers.js'

function appearOnIntersect( selector = '.ob', className = 'active' )
{
  //observer for showing items
  const observer = new IntersectionObserver( entries => {
    entries.forEach( ({ isIntersecting, target }) => {
      if( isIntersecting && !target.classList.contains( className ) )
      {
        const image = target.querySelector( 'picture>img' ) || target.querySelector( 'figure.picture>img' ) || target.querySelector( 'img' )
        if( image ){
          imageApplyDataAttr( image, ({ target }) => {
            target.classList.add( className )
          })
        }
        //add active
        target.classList.add( className )
      }
    })
  })

  const observed = document.querySelectorAll( selector )
  observed.forEach( item => {
    observer.observe( item )
  })

}

export {
  appearOnIntersect,
}
